import { useT } from '../layout/i18n.ts';

export interface ErrorEnvelopeView {
  readonly code: string;
  readonly messageKey: string;
  readonly params?: Record<string, string | number>;
  readonly requestId?: string;
  readonly details?: readonly { readonly field: string; readonly messageKey: string }[];
}

/** Renders the API error envelope (02 §6.2) in the user's locale; announced via role=alert. */
export function ErrorBanner({ error }: { readonly error: ErrorEnvelopeView | null }) {
  const t = useT();
  if (!error) return null;
  return (
    <div role="alert" className="skm-error" data-code={error.code}>
      <p>{t(error.messageKey, error.params)}</p>
      {error.details?.length ? (
        <ul>
          {error.details.map((d) => (
            <li key={`${d.field}:${d.messageKey}`}>
              {d.field}: {t(d.messageKey)}
            </li>
          ))}
        </ul>
      ) : null}
      {error.requestId ? <small>{t('ui.error.reference', { id: error.requestId })}</small> : null}
    </div>
  );
}
